import { Get, Post, PostFormData } from "../Request/Api";
export default {
  state: {
    courseId: null,
    specificCourseAllSeminarByGroup: [],
    courseRegisterFee: null,
    seminarMonitorDiscountRate:null,
    seminarDetails: null,
    courseDetails: null,
    instructorDetails: null,
    BeginnerCourses: [],
    Courses: [],
    Categories: [],
    SeminarByGroup: [],
    CoursesGroupByCategories: [],
    AllSeminarGroupByCourses: [],
    SeminarBySeminarIdAndUserId: [],
    BillingDetailsInfoByUserId: [],
    CourseById: [],
    userEligibleForSeminar: [],
    enrolledCourseOrSeminarByUserId: [],
    CourseCategories: [],
    region: null,
    country: null,
    state: null,
    city: null,
    filterInstructorFirstName: null,
    filterInstructorLastName: null,
    filterCourse: null,
    filterCategory: [],
    filterCourseType: null,
    filterLanguage: null,
    dates: [],
    beginnerRegion: null,
    beginnerCountry: null,
    beginnerCity: null,
    beginnerState: null,
  },
  getters: {
    GetCourseCategories(state: any) {
      return state.CourseCategories;
    },
    GetCourses(state: any) {
      return state.BeginnerCourses;
    },
    GetUserEligibleForSeminar(state: any) {
      return state.userEligibleForSeminar;
    },
    GetEnrolledCourseOrSeminarByUserId(state: any) {
      return state.enrolledCourseOrSeminarByUserId;
    },
    GetCourseById(state: any) {
      return state.CourseById;
    },
    getBillingDetailsInfoByUserId(state: any) {
      return state.BillingDetailsInfoByUserId;
    },
    GetCourse(state: any) {
      return state.Courses;
    },
    GetAllSeminarByGroup(state: any) {
      return state.SeminarByGroup;
    },
    GetSpecificCourseAllSeminarByGroup(state: any) {
      return state.specificCourseAllSeminarByGroup;
    },
    GetCoursesGroupByCategories(state: any) {
      return state.CoursesGroupByCategories;
    },
    GetAllSeminarGroupByCourses(state: any) {
      return state.AllSeminarGroupByCourses;
    },
    GetSeminarBySeminarIdAndUserId(state: any) {
      return state.SeminarBySeminarIdAndUserId;
    },
  },
  actions: {
    async GetCourses({ commit }: any, payload: any) {
      return await Get(`Course/GetBeginnerCourses`).then((res: any) => {
        commit("SetBeginnerCourses", res.data.Data);
        return res.data.Data;
      });
    },
    async GetCourseCategories({ commit }: any) {
      return await Get("Course/GetCourseCategories").then((res: any) => {
        commit("SetCourseCategories", res.data.Data);
        return res.data.Data;
      });
    },
    async GetCourseById({ commit }: any, payload: any) {
      return await Get(
        `Course/GetCourseById?Id=${payload.Id}&WebMode=true`
      ).then((res: any) => {
        commit("SetCourseById", res.data.Data);
        return res.data.Data;
      });
    },
    async GetLiveCourse({ commit }: any, payload: any) {
      return await Get(
        `Course/GetCourses/${payload.page}?pageSize=${
          payload.pageSize
        }&search=${payload.search ?? ""}&filters=${payload.filters}`
      ).then((res: any) => {
        if (res.data.Data) {
          commit("SetCourses", res.data.Data.List);
        }
        return res.data;
      });
    },
    async GetCoursesGroupByCategories({ commit }: any, payload: any) {
      return await Get(`Course/GetCoursesGroupByCategories`).then(
        (res: any) => {
          if (res.data.Data) {
            commit("SetCoursesGroupByCategories", res.data.Data);
          }
          return res.data;
        }
      );
    },
    async GetAllSeminarByGroup({ commit }: any, payload: any) {
      return await Get(
        `Seminar/GetAllSeminarByGroup?page=1&pageSize=all&search=${payload.search}&filters=${payload.filters}`
      ).then((res: any) => {
        commit("SetAllSeminarByGroup", res.data.Data.List);
        return res.data.Data;
      });
    },
    async GetSpecificCourseAllSeminarByGroup({ commit }: any, payload: any) {
      return await Get(
        `Seminar/GetAllSeminarByGroup?page=1&pageSize=all&search=${payload.search}&filters=${payload.filters}`
      ).then((res: any) => {
        commit("SetCourseId", payload.courseId);
        commit(
          "SetSpecificCourseAllSeminarByGroup",
          res.data.Data.List,
          payload.courseId
        );
        return res.data.Data;
      });
    },
    async GetAllSeminarGroupByCourses({ commit }: any, payload: any) {
      return await Get(
        `Seminar/GetAllSeminarGroupByCourses?page=1&pageSize=10&search=${payload.search}&filters=${payload.filters}`
      ).then((res: any) => {
        commit("SetAllSeminarGroupByCourses", res.data?.Data?.List);
        return res.data.Data;
      });
    },
    async GetSeminarBySeminarIdAndUserId({ commit }: any, payload: any) {
      return await Get(
        `Seminar/GetSeminarBySeminarIdAndUserId?seminarId=${payload.seminarId}&userId=${payload.id}`
      ).then((res: any) => {
        commit("SetSeminarBySeminarIdAndUserId", res.data.Data);
        return res.data.Data;
      });
    },
    async GetBillingDetailsInfoByUserId({ commit }: any, payload: any) {
      return await Get(
        `UserBillingDetail/GetBillingDetailsInfoByUserId?userId=${payload.id}`
      ).then((res: any) => {
        commit("SetBillingDetailsInfoByUserId", res.data.Data);
        return res.data.Data;
      });
    },
    async EnrollCourseOrSeminar({ commit }: any, payload: any) {
      return await Post("Enrollment/EnrollCourseOrSeminar", payload).then(
        (res: any) => {
          return res.data;
        }
      );
    },
    async CreatePaymentAsync({ commit }: any, payload: any) {
      return await Post("PayPal/CreatePaymentAsync", payload).then(
        (res: any) => {
          return res.data;
        }
      );
    }, 
    async GetPaymentDetailsFromURL({ commit }: any, payload: any) {
      const encodedUrl = encodeURIComponent(payload.url);
      return await Post(`PayPal/GetPaymentDetailsFromURL?url=${encodedUrl}`, {})
        .then((res: any) => {
          return res.data;
        })
        .catch((error: any) => {
          console.error("Error fetching payment details:", error);
          throw error;
        });
    },

    // async ExecutePaymentAsync({ commit }: any, payload: any) {
    //   return await Post("PayPal/ExecutePaymentAsync", payload)
    //     .then((res: any) => {
    //       return res.data;
    //     })
    //     .catch((error: any) => {
    //       console.error("Error executing payment:", error);
    //       throw error;
    //     });
    // },
    async EnrollNonIBAPaymentSeminar({ commit }: any, payload: any) {
      return await Post(
        `Enrollment/EnrollNonIBAPaymentSeminar?seminarId=${payload.seminarId}&userId=${payload.userId}&PaidAmount=${payload.PaidAmount}`,
        {}
      ).then((res: any) => {
        return res.data;
      });
    },
    async GetUserEligibleForSeminar({ commit }: any, payload: any) {
      return await Get(
        `Enrollment/CheckUserEligibleForSeminar?seminarId=${payload.seminarId}&userId=${payload.id}`
      ).then((res: any) => {
        commit("SetUserEligibleForSeminar", res.data.Data);
        return res.data.Data;
      });
    },
    async GetEnrolledCourseOrSeminarByUserId({ commit }: any, payload: any) {
      return await Get(
        `Enrollment/GetEnrolledCourseOrSeminarByUserId?userId=${payload.id}`
      ).then((res: any) => {
        commit("SetEnrolledCourseOrSeminarByUserId", res.data.Data);
        return res.data.Data;
      });
    },
  },
  mutations: {
    SetCourseCategories(state: any, payload: any) {
      state.CourseCategories = payload;
    },
    SetUserEligibleForSeminar(state: any, payload: any) {
      state.userEligibleForSeminar = payload;
    },
    SetEnrolledCourseOrSeminarByUserId(state: any, payload: any) {
      const currentDate = new Date();
      let allSeminarDates: any = [];
      payload.forEach((item: any) => {
        item.SeminarDateAndTime.forEach((seminar: any) => {
          allSeminarDates.push({ ...seminar, itemId: item.Id });
        });
      });
      currentDate.setHours(0, 0, 0, 0);

      allSeminarDates.sort((a: any, b: any) => {
        const dateA: any = new Date(a.Date);
        dateA.setHours(0, 0, 0, 0);

        const dateB: any = new Date(b.Date);
        dateB.setHours(0, 0, 0, 0);

        if (dateA >= currentDate && dateB >= currentDate) {
          return dateA - dateB; 
        } else if (dateA >= currentDate) {
          return -1; 
        } else if (dateB >= currentDate) {
          return 1;
        } else {
          return dateB - dateA;
        }
      });

      let seminars: any = [];
      const itemIdSet = new Set();
      allSeminarDates = allSeminarDates.filter((item: any) => {
        if (itemIdSet.has(item.itemId)) {
          return false;
        } else {
          itemIdSet.add(item.itemId);
          return true;
        }
      });
      allSeminarDates.forEach((element: any) => {
        payload.forEach((item: any) => {
          if (element.itemId == item.Id) {
            seminars.push(item);
          }
        });
      });
      payload.forEach((item: any) => {
        if(item.SeminarDateAndTime.length == 0){
          seminars.push(item);
        }
      });
      state.enrolledCourseOrSeminarByUserId = seminars;
    },
    SetBeginnerCourses(state: any, payload: any) {
      payload = payload.map((x: any) => {
        x.ImgVid =
          x.Banner != null && x.Banner != undefined && x.Banner != ""
            // ? process.env.VUE_APP_IMG_URL + "/" + x.Banner
            ? x.Banner
            : x.Banner;
        x.Thumbnail =
          x.Thumbnail != null && x.Thumbnail != undefined && x.Thumbnail != ""
            ? x.Thumbnail
            : x.Thumbnail;
        return x;
      });
      state.BeginnerCourses = payload;
    },
    SetCourses(state: any, payload: any) {
      state.Courses = payload;
    },
    SetCourseById(state: any, payload: any) {
      state.CourseById = payload;
    },
    SetAllSeminarByGroup(state: any, payload: any) {
      const sortedPayload = [...payload];
      sortedPayload.sort((a, b) => {
        if (a.Year !== b.Year) {
          return a.Year - b.Year;
        } else {
          const months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];
          const monthA = months.indexOf(a.Month);
          const monthB = months.indexOf(b.Month);
          return monthA - monthB;
        }
      });
      state.SeminarByGroup = sortedPayload;
    },
    SetCourseId(state: any, payload: any) {
      state.courseId = payload;
    },
    SetSpecificCourseAllSeminarByGroup(state: any, payload: any) {
      payload.forEach((item: any) => {
        const filteredSeminars = item.Seminars.filter(
          (element: any) => element.Course.Id == state.courseId
        );
        item.Seminars = filteredSeminars;
      });
      payload = payload.filter((item: any) => item.Seminars?.length > 0);
      const sortedPayload = [...payload];
      sortedPayload.sort((a, b) => {
        if (a.Year !== b.Year) {
          return a.Year - b.Year;
        } else {
          const months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];
          const monthA = months.indexOf(a.Month);
          const monthB = months.indexOf(b.Month);
          return monthA - monthB;
        }
      });
      state.specificCourseAllSeminarByGroup = sortedPayload;
    },
    SetCoursesGroupByCategories(state: any, payload: any) {
      state.CoursesGroupByCategories = payload;
    },
    SetAllSeminarGroupByCourses(state: any, payload: any) {
      state.AllSeminarGroupByCourses = payload;
    },
    SetSeminarBySeminarIdAndUserId(state: any, payload: any) {
      state.SeminarBySeminarIdAndUserId = payload;
    },
    SetBillingDetailsInfoByUserId(state: any, payload: any) {
      state.BillingDetailsInfoByUserId = payload;
    },
  },
};
